/**
 * v3.5 (May 12) - global Part Card dialog state.
 *
 * Mirrors useCustomerCardDialog so any component can open the Part
 * Detail card without owning the dialog state. The actual dialog lives
 * in App.vue and listens to this composable.
 *
 * Usage:
 *   const { open } = usePartCardDialog()
 *   open(partId)
 */
import { ref } from 'vue'

const isOpen = ref(false)
const partId = ref(null)

export function usePartCardDialog() {
  function open(id) {
    if (!id) return
    partId.value = id
    isOpen.value = true
  }
  function close() {
    isOpen.value = false
  }
  return { isOpen, partId, open, close }
}
